import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Suspense, lazy } from 'preact/compat';
const SelectGroup = lazy(
    () => import(/* webpackChunkName: "select-group" */ '../../shared/form/select-group')
);

dayjs.extend(customParseFormat);
dayjs.extend(localeData);
dayjs.locale('en');

class Component extends BaseComponent {
    constructor() {
        super();

        const cardMap = {
            1: 'magician',
            2: 'high-priestess',
            3: 'empress',
            4: 'emperor',
            5: 'hierophant',
            6: 'lovers',
            7: 'chariot',
            8: 'strength',
            9: 'hermit',
            10: 'wheel-of-fortune',
            11: 'justice',
            12: 'hanged-man',
            13: 'death',
            14: 'temperance',
            15: 'devil',
            16: 'tower',
            17: 'star',
            18: 'moon',
            19: 'sun',
            20: 'judgement',
            21: 'world',
        };

        // Expose the map to other methods
        this.cardMap = cardMap;

        const currentYear = dayjs().year();
        const days = Array.from({ length: 31 }, (_, i) => i + 1);
        const months = dayjs.months();
        const years = Array.from({ length: 131 }, (_, i) => currentYear + 30 - i);

        this.state = {
            formError: null,
            month: {
                value: '',
                error: false,
            },
            months: months,
            day: {
                value: '',
                error: false,
            },
            days: days,
            year: {
                value: currentYear,
                error: false,
            },
            years: years,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState != this.state) {
            return true;
        }

        return false;
    }

    render(props, { formError, ...state }) {
        return (
            <tarot-card-of-year-calculator className='is-block has-text-center has-padding-20-top'>
                <h3>
                    Enter Your Birthday and Your Desired Year
                </h3>
                <h4>We'll calculate your personal Tarot card for ...</h4>
                <form onSubmit={this.submit} className='has-padding-20'>
                    <row className='is-wrap'>
                        {['month', 'day', 'year'].map((period) => (
                            <column className='is-4 is-12-mobile has-padding-5-right'>
                                <Suspense fallback={<div className='skeleton' />}>
                                    <SelectGroup
                                        name={period}
                                        value={state[period].value}
                                        placeholder={period.toUpperCase()}
                                        options={state[period + 's']}
                                        error={state[period].error}
                                        onChange={this.setFormValues}
                                    />
                                </Suspense>
                            </column>
                        ))}
                        <column className='is-12'>
                            <button className='has-margin-10-top button'>Reveal Your Card</button>
                            {formError && <p className='is-error'>{formError}</p>}
                        </column>
                    </row>
                </form>
            </tarot-card-of-year-calculator>
        );
    }

    setFormValues = (e) => {
        let state = [];

        if ((e.type == 'keyup' && e.key == 'Enter') || e.type == 'change') {
            state[e.target.name] = {
                value: e.target.value,
                error: false,
            };

            state.formError = null;
        }

        this.setState(state);
    }

    calculateBirthCardIndex = (datestring) => {
        // Add all individual digits together: m + m + d + d + y + y + y + y
        // Example: 01/03/2025 -> 0 + 1 + 0 + 3 + 2 + 0 + 2 + 5 = 13 (Death)
        const digits = datestring.split('').map(Number);
        let sum = digits.reduce((acc, digit) => acc + digit, 0);

        // If Index no. > 21, then sum the digits repeatedly until <= 21
        // Example: 09/29/2025 = 2+9+2+9+2+0+2+5 = 29 -> 2+9 = 11 (Justice)
        while (sum > 21) {
            sum = sum
                .toString()
                .split('')
                .map((n) => parseInt(n, 10))
                .reduce((acc, n) => acc + n, 0);
        }

        return parseInt(sum);
    }

    submit = (e) => {
        e.preventDefault();

        const state = this.state;
        state.formError = null;

        ['month', 'day', 'year'].forEach((field) => {
            if (!state[field].value) {
                state[field].error = true;
                state.formError = 'Please fill out highlighted areas above to submit';
            }
        });

        if (!state.formError) {
            const month = dayjs.months().indexOf(this.state.month.value) + 1;
            const date = dayjs(`${month}/${this.state.day.value}/${this.state.year.value}`,
                'M/D/YYYY').format('MM/DD/YYYY');

            if (dayjs(date, 'MM/DD/YYYY', true).isValid()) {
                const card_index = this.calculateBirthCardIndex(dayjs(date).format('MMDDYYYY'));

                this.props.trackEvent([
                    'Click',
                    `Calculator_BirthCards:${this.cardMap[card_index]}`,
                ]);

                window.location.href = `/tarot/tarot-card-year-${this.cardMap[card_index]}`;
            } else {
                state.formError = 'Please enter a valid date to submit';
            }
        }

        this.setState(state);
    }
}

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(null, mapDispatchToProps)(Component);
